import { useStore } from 'zustand';
import { DiagramState } from '../../store/diagram.store';
import { useContext } from 'react';
import { DiagramStoreContext } from '../../store/store.context';

export const useDiagramStore = <T>(selector: (s: DiagramState) => T): T => {
  const store = useContext(DiagramStoreContext);
  if (!store) {
    throw new Error(
      'useDiagramStore must be used within a DiagramStoreProvider'
    );
  }
  return useStore(store, selector);
};
